import * as React from 'react';
import type { SVGProps } from 'react';
const SvgActivityLogs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.442 3.202a.54.54 0 0 1 0 .764L4.724 5.684a.63.63 0 0 1-.892 0l-.851-.851a.54.54 0 1 1 .764-.765l.533.533 1.4-1.4a.54.54 0 0 1 .764 0Zm0 5.355a.54.54 0 0 1 0 .765L4.724 11.04a.63.63 0 0 1-.892 0l-.851-.852a.54.54 0 0 1 .764-.764l.533.533 1.4-1.4a.54.54 0 0 1 .764 0"
      clipRule="evenodd"
    />
    <path d="M8.118 4.456a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75m0 5.356a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75m0 5.693a.75.75 0 0 1 .75-.75h7.56a.75.75 0 0 1 0 1.5h-7.56a.75.75 0 0 1-.75-.75" />
    <path
      fillRule="evenodd"
      d="M6.442 13.928a.54.54 0 0 1 0 .764L4.724 16.41a.63.63 0 0 1-.892 0l-.851-.851a.54.54 0 0 1 .764-.764l.533.533 1.4-1.4a.54.54 0 0 1 .764 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgActivityLogs;
